import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface AddTaskProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function AddTask({ color = RoutalPalette.primary40, style = {} }: AddTaskProps) {
  return (
    <SvgIcon width="13" height="13" viewBox="0 0 13 13" style={{ height: `14px`, width: `14px`, ...style }}>
      <g fill="none">
        <path
          d="M3.51877 1.43609L3.53103 1.4367H3.54331H11.1633H11.1757L11.1881 1.43608C11.4178 1.42468 11.6186 1.6008 11.6353 1.83467V9.6103C11.6185 9.84287 11.4192 10.0204 11.1879 10.009L11.1756 10.0084H11.1633H3.54331H3.53091L3.51853 10.009C3.28884 10.0204 3.08802 9.84432 3.07129 9.61045V1.83482C3.0881 1.60224 3.28745 1.42473 3.51877 1.43609Z"
          fill={color}
          stroke={color}
        />
        <path d="M9.5848 5.72151H5.12224" stroke="#FAFAFA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.35352 3.49023V7.9528" stroke="#FAFAFA" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M9.91426 12.0732H2.03739C1.48339 12.0732 1.03516 11.6239 1.03516 11.0686V2.1582"
          stroke={color}
          strokeLinecap="round"
        />
      </g>
    </SvgIcon>
  );
}
